module.exports = __webpack_public_path__ + "images/arvid_614f99accf4fee3df3498508f71f24ea.jpg";